import { WebSocketChat } from '@meddev/fe-shared';
import { Observable } from 'rxjs';

export abstract class MessagingAdapterBase {
    abstract initWebSocket(bookingId: string | undefined): Observable<void>;
    abstract getChatData(): Observable<WebSocketChat[]>;
    abstract sendMessage(message: WebSocketChat): void;
    abstract closeSocket(bookingId: string | undefined): void;
}
